import React from 'react';

import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import BaseButton, { IBaseButtonProps } from './_module/BaseButton';

const useStyles = makeStyles<Theme, IProps>((theme) => ({
  button: {
    backgroundColor: ({ status }) =>
      status ? theme.palette.primary.main : '#ff1744',
    '&:hover': {
      backgroundColor: ({ status }) =>
        status ? theme.palette.primary.dark : '#e80729',
    },
  },
}));

interface IProps extends IBaseButtonProps {
  text?: string;
  status: boolean;
}

export default function ButtonShutdown(props: IProps) {
  const {
    color,
    variant,
    onClick,
    text,
    size,
    disabled,
    fullWidth,
    status,
  } = props;

  const classes = useStyles(props);
  return (
    <BaseButton
      className={classes.button}
      color={color}
      fullWidth={fullWidth}
      disabled={disabled}
      variant={variant}
      onClick={onClick}
      size={size}
      startIcon={
        <PowerSettingsNewIcon
          htmlColor="#fff"
          fontSize={size === 'small' ? 'small' : undefined}
        />
      }
    >
      {text}
    </BaseButton>
  );
}
